<mat-dialog-content class="mat-typography">
    <div class="container">
        <div class="title_modal" (click)="log()">
            {{ 'Add Regular Publications' | translate }}
        </div>

        <div class="table_wrp">
            <table>
                <thead>
                    <tr>
                        <th scope="col">{{"Channel" | translate}}</th>
                        <th scope="col">{{"Regular Title" | translate}}</th>
                        <th scope="col">
                            {{"Regular Format" | translate}}
                            <div style="font-size: 8px; text-align: center;">{{"Every" | translate}}</div>
                        </th>
                        <th scope="col">{{"From Time" | translate}}</th>
                        <th scope="col">{{"To Time" | translate}}</th>
                        <th scope="col">{{"Slots" | translate}}</th>
                        <!-- <th scope="col" *ngFor="let slot of slots; let i = index">{{"Slot" | translate}}</th> -->
                    </tr>
                    <tr [formGroup]="form">
                       <th scope="row"></th>
                       <td>
                            <input type="text" formControlName="name">
                       </td>
                       <td>
                            <mat-button-toggle-group appearance="legacy" formControlName="type">
                                <mat-button-toggle [value]="0">{{ "Day" | translate }}</mat-button-toggle>
                                <mat-button-toggle [value]="1">{{ "Week" | translate }}</mat-button-toggle>
                                <mat-button-toggle [value]="2">{{ "Month" | translate }}</mat-button-toggle>
                            </mat-button-toggle-group>
                       </td>
                       <td>
                            <mat-form-field class="full_width_form" appearance="standard">
                                <mat-label>{{ "Apply from time" | translate }}</mat-label>
                                <input matInput [ngxMatDatetimePicker]="pickerFrom" placeholder="Choose a date" formControlName="apply_from_time">
                                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #pickerFrom [showSpinners]="true" [touchUi]="false" [color]="'primary'">
                
                                <ng-template>
                                    <span>OK</span>
                                </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                       </td>
                       <td>
                            <mat-form-field class="full_width_form" appearance="standard">
                                <mat-label>{{ "Apply to time" | translate }}</mat-label>
                                <input matInput [ngxMatDatetimePicker]="pickerTo" placeholder="Choose a date" formControlName="apply_to_time">
                                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #pickerTo [showSpinners]="true" [touchUi]="false" [color]="'primary'">
                                <ng-template>
                                    <span>OK</span>
                                </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                       </td>
                       <td>

                            <div class="d-f-c">
                                <input type="text" formControlName="regName">

                                <span class="shfl" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Shuffle hours' }}" [matMenuTriggerFor]="hhMenu">
                                    HH
                                    <mat-icon>shuffle</mat-icon>
                                </span>

                                <mat-menu #hhMenu="matMenu" xPosition="after">
                                    <div class="pad" style="padding: 10px;">
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Min" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="hhMin">
                                        </mat-form-field>
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Max" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="hhMax">
                                        </mat-form-field>
                                    </div>

                                    <button mat-menu-item (click)="shuffleTime('h', hhMin.value, hhMax.value)">
                                        <span>{{ "Shuffle" | translate }}</span>
                                    </button>
                                </mat-menu>

                                <span class="shfl" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Shuffle minutes' }}" [matMenuTriggerFor]="mmMenu">
                                    MM
                                    <mat-icon>shuffle</mat-icon>
                                </span>

                                <mat-menu #mmMenu="matMenu" xPosition="after">
                                    <div class="pad" style="padding: 10px;">
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Min" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="mmMin">
                                        </mat-form-field>
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Max" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="mmMax">
                                        </mat-form-field>
                                    </div>

                                    <button mat-menu-item (click)="shuffleTime('m', mmMin.value, mmMax.value)">
                                        <span>{{ "Shuffle" | translate }}</span>
                                    </button>
                                </mat-menu>
    
                                <div class="ml-1 add_slot" (click)="addSlot()">
                                    <mat-icon>add</mat-icon>
                                    <span>{{"Slots" | translate}}</span>
                                </div>
                            </div>
                       </td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of channelsToGroup; let j = index;">
                        <th scope="row">
                            <app-outlet-line [channel]="item.channel" [company_id]="data.company.id"></app-outlet-line>
                            {{getContentTypeById(item.content_type_id)?.name | translate}}
                            <mat-icon class="icon_del" (click)="deleteRow(j)" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Remove Channel from this list' }}">delete</mat-icon>
                        </th>
                        <td>
                            <input type="text" [(ngModel)]="item.form.name">
                        </td>
                       <td>
                            <mat-button-toggle-group appearance="legacy" [(ngModel)]="item.form.type">
                                <mat-button-toggle [value]="0">{{ "Day" | translate }}</mat-button-toggle>
                                <mat-button-toggle [value]="1">{{ "Week" | translate }}</mat-button-toggle>
                                <mat-button-toggle [value]="2">{{ "Month" | translate }}</mat-button-toggle>
                            </mat-button-toggle-group>
                       </td>
                       <td>
                            <mat-form-field class="full_width_form" appearance="standard">
                                <mat-label>{{ "Apply from time" | translate }}</mat-label>
                                <input matInput [ngxMatDatetimePicker]="pickerFrom" placeholder="Choose a date" [(ngModel)]="item.form.apply_from_time">
                                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #pickerFrom [showSpinners]="true" [touchUi]="false" [color]="'primary'">
                
                                <ng-template>
                                    <span>OK</span>
                                </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                       </td>
                       <td>
                            <mat-form-field class="full_width_form" appearance="standard">
                                <mat-label>{{ "Apply to time" | translate }}</mat-label>
                                <input matInput [ngxMatDatetimePicker]="pickerTo" placeholder="Choose a date" [(ngModel)]="item.form.apply_to_time">
                                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #pickerTo [showSpinners]="true" [touchUi]="false" [color]="'primary'">
                                <ng-template>
                                    <span>OK</span>
                                </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                       </td>
                       <td>
                            <div class="slot" *ngFor="let slot of item.slots; let slotInd = index;">
                                <input type="text" [(ngModel)]="slot.name" placeholder="{{ 'Regular publication name' | translate }}">

                                <div class="ngx-timepicker-field-example ml-1">
                                    <ngx-timepicker-field [format]="24" [(ngModel)]="slot.timeInFormat"></ngx-timepicker-field>
                                </div>

                                <b class="ml-1" *ngIf="item.form.type != 0">{{'Day' | translate}}:</b>

                                <select [(ngModel)]="slot.day_number" *ngIf="item.form.type == 1">
                                    <option *ngFor="let day of weekDays; let m = index;" [value]="m+1">
                                        {{ m+1 }}
                                    </option>
                                </select>

                                <select [(ngModel)]="slot.day_number" *ngIf="item.form.type == 2">
                                    <option *ngFor="let day of monthDays; let m = index;" [value]="m+1">
                                        {{ m+1 }}
                                    </option>
                                </select>

                                
                                <span class="shfl" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Shuffle hours' }}" [matMenuTriggerFor]="hhMenu">
                                    HH
                                    <mat-icon>shuffle</mat-icon>
                                </span>

                                <mat-menu #hhMenu="matMenu" xPosition="after">
                                    <div class="pad" style="padding: 10px;">
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Min" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="hhMin">
                                        </mat-form-field>
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Max" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="hhMax">
                                        </mat-form-field>
                                    </div>

                                    <button mat-menu-item (click)="shuffleTime('h', hhMin.value, hhMax.value, slot)">
                                        <span>{{ "Shuffle" | translate }}</span>
                                    </button>
                                </mat-menu>

                                <span class="shfl" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ 'Shuffle minutes' }}" [matMenuTriggerFor]="mmMenu">
                                    MM
                                    <mat-icon>shuffle</mat-icon>
                                </span>

                                <mat-menu #mmMenu="matMenu" xPosition="after">
                                    <div class="pad" style="padding: 10px;">
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Min" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="mmMin">
                                        </mat-form-field>
                                        <mat-form-field class="full_width_form" appearance="legacy" (click)="$event.preventDefault(); $event.stopPropagation()">
                                            <mat-label>{{ "Max" | translate }}</mat-label>
                                            <input matInput type="number" [formControl]="mmMax">
                                        </mat-form-field>
                                    </div>

                                    <button mat-menu-item (click)="shuffleTime('m', mmMin.value, mmMax.value, slot)">
                                        <span>{{ "Shuffle" | translate }}</span>
                                    </button>
                                </mat-menu>
                                
                                <mat-icon class="remove" (click)="removeSlot(item, slotInd)">close</mat-icon>
                            </div>
                            <div class="add_slot" (click)="addSlot(item)">
                                <mat-icon>add</mat-icon>
                                <span>{{"Slot" | translate}}</span>
                            </div>
                       </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="f_w_p_btns">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="onSubmit()" cdkFocusInitial mat-raised-button color="primary" [disabled]="isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Create" | translate }}
        </button>
    </div>
</mat-dialog-actions>
